import { wishlist, type Wishlist, type WishlistItem } from "@repo/core/wishlist";

export const LOCAL_WISHLIST_STORAGE_KEY = "ng_wishlist";

export function getWishlistFromLocalStorage(): Wishlist {
  if (typeof window === "undefined") {
    return emptyWishlist();
  }

  const data = localStorage.getItem(LOCAL_WISHLIST_STORAGE_KEY) ?? "";
  try {
    return wishlist.parse(JSON.parse(data));
  } catch {
    return emptyWishlist();
  }
}

export function clearWishlistFromLocalStorage(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(LOCAL_WISHLIST_STORAGE_KEY);
}

export function addWishlistItemToLocalStorage(item: {
  productId: string;
  variantId: string;
}): void {
  const current = getWishlistFromLocalStorage();
  const wishlistItems = [
    ...(current.wishlistItems ?? []),
    { productId: item.productId, variantId: item.variantId },
  ];

  localStorage.setItem(
    LOCAL_WISHLIST_STORAGE_KEY,
    JSON.stringify({
      wishlistItems,
      metadata: { totalItems: wishlistItems.length },
    }),
  );
}

export function deleteWishlistItemFromLocalStorage(
  wishlistItem: WishlistItem,
): void {
  try {
    const current = getWishlistFromLocalStorage();
    const wishlistItems = [...(current.wishlistItems ?? [])].filter(
      (item) =>
        item.productId !== wishlistItem.productId ||
        item.variantId !== wishlistItem.variantId,
    );

    if (wishlistItems.length === 0) {
      clearWishlistFromLocalStorage();
      return;
    }

    localStorage.setItem(
      LOCAL_WISHLIST_STORAGE_KEY,
      JSON.stringify({
        wishlistItems,
        metadata: { totalItems: wishlistItems.length },
      }),
    );
  } catch {}
}

function emptyWishlist(): Wishlist {
  return {
    wishlistItems: [],
    metadata: {
      totalItems: 0,
    },
  };
}
